import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { useData } from "../../DataContext";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Helmet } from "react-helmet";
import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormLabel,
    FormControl,
    Button,
    Box,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    TextField,
    Input,
    Modal,
    Fade
} from '@material-ui/core';
import InputMask from 'react-input-mask';
import { makeStyles } from '@material-ui/core/styles'

import './VehicleDetail.scss'
import errorWarning from '../../images/icon_warning.gif'
import sampleLetter from "../../images/sampleVRDoc.gif";

import {
    Navbar,
    Header,
    StepHeader,
    FormBox,
    BootstrapInput,
    DatePicker,
    FileInput,
    Footer,
    LoadingSpinner
} from '../../components/_index'
import ErrorsContainer from '../../components/ErrorsContainer/ErrorsContainer';
import { useYupValidationResolver } from '../../YupValidationResolver';
import { LocalConvenienceStoreOutlined } from '@material-ui/icons';
// import { DatePicker } from '@material-ui/pickers';
import Scroll from 'react-scroll';
import { checkIfRedirect, dateMask, isEmpty, isObjectEmpty, trimRegmark } from '../../utils';
import moment from 'moment';

const vehicleType = [
    'step3.vehicle.vehicleTypeOpt1',
    'step3.vehicle.vehicleTypeOpt2',
    'step3.vehicle.vehicleTypeOpt3',
    'step3.vehicle.vehicleTypeOpt4',
    'step3.vehicle.vehicleTypeOpt5',
    'step3.vehicle.vehicleTypeOpt6',
    'step3.vehicle.vehicleTypeOpt7',
    'step3.vehicle.vehicleTypeOpt8',
    'step3.vehicle.vehicleTypeOpt9',
    'step3.vehicle.vehicleTypeOpt10',
]

// let vehicleCount = 1;

const useStyles = makeStyles((theme) => ({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      width: 360,
    },
}));

export default withTranslation()(function VehicleDetail({t, i18n}) {
    let scroll = Scroll.animateScroll;
    const { setValues, data } = useData();
    const lang = i18n.language;
    const history = useHistory();
    const [ customError, setCustomError ] = useState([]);

    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    
    checkIfRedirect(data, history);

    checkIfRedirect(data, history);

    // uncomment the following to enable validation
    const schema = yup.object().shape({
        vehicleDetail: yup.string().required(t("errors.frontend.790-E-0401")),
        vehicleGp: yup.array().test("at-least-one", t("errors.frontend.790-E-0402"), (vehicleGpArr) => (vehicleGpArr.length>0))
        .ensure().of(
            yup.object().shape({
                vehicleRegNo: yup.string().required(t("errors.frontend.790-E-0403")),
                issueDate: yup.date().typeError(t("errors.frontend.790-E-0404"))
                // vehicleType: ,
            })
        )
    })

    const {
        setValue,
        register,
        handleSubmit,
        control,
        errors,
        clearErrors,
        watch,
        reset
    } = useForm({
        defaultValues: {
            vehicleDetail: data.vehicleDetail || 'direct',
            vehicleGp: (!data.vehicleGp||data.vehicleGp.length<1) ?
            (
                [
                    {
                        vehicleRegNo: '',
                        issueDate: '',
                        // vehicleType: '',
                    }
                ]
            ) :
            (
                data && data.vehicleGp && data.vehicleGp.map((obj) => {
                    // console.log("obj.issueDate: ", obj && obj.issueDate)
                    return {
                        vehicleRegNo: obj.vehicleRegNo,
                        issueDate: moment(obj.issueDate).format("YYYY-MM-DD"),
                    }
                })
            )
        },
        mode: "onSubmit",
        resolver: useYupValidationResolver(schema),
    });

    const { fields, append, remove } = useFieldArray(
        {
            control,
            name: 'vehicleGp'
        }
    );

    const vehicleDetailSelected = watch('vehicleDetail')
    const vehicleGpWatch = watch('vehicleGp');

    const handleAddVehicle = () => {
        if (data && data.vehicleGp && data.vehicleGp.length >= 10) return;

        append({
            vehicleRegNo: '',
            issueDate: '',
            // vehicleType: ''
        })
    }

    const onSubmit = (formData) => {
        let customErrorTmp = new Object();
        let allCorrect = true;
        let count = 0;
        // formData.vehicleGp = formData.vehicleGp.map((vehicle)=>({...vehicle, vehicleRegNo: vehicle.vehicleRegNo.toUpperCase().replace(/^\s+/,'').replace(/\s+$/,'')}))
        trimRegmark(formData.vehicleGp)

        setOpen(true);

        formData.vehicleGp.forEach((vehicle, index, array) => {
            if(data.applicantType=="Government"&&vehicle.vehicleRegNo.startsWith("AM")){
                count++;
                if(count == array.length){
                    console.log("AllCorrect: " + allCorrect);
                    setCustomError(customErrorTmp);
                    onCustomError(customErrorTmp);
                    if(allCorrect){
                        console.log('onSubmit: ', formData, formData.vehicleGp);
                        setValues(formData);
                        history.push(`${process.env.REACT_APP_SUB_ROUTE}/locationDetail`);
                    }
                }
            } else {
                checkRegistration(vehicle.vehicleRegNo,vehicle.issueDate)
                .then((validation) => {
                    console.log(validation);
                    if(validation == 0){
                        console.log("==0");
                    }else if(validation == 1){
                        console.log("==1");
                        let vehicleName = "vehicleGp[" + index + "].issueDate";
                        customErrorTmp[vehicleName] = {"message": t("errors.frontend.790-E-0405")};
                        allCorrect = false;
                    }else if(validation == 2){
                        console.log("==2");
                        let vehicleName = "vehicleGp[" + index + "].issueDate";
                        customErrorTmp[vehicleName] = {"message": t("errors.frontend.790-E-0406")};
                        allCorrect = false;
                    }else if(validation == 3){
                        console.log("==else");
                        let vehicleName = "vehicleGp[" + index + "].vehicleRegNo";
                        customErrorTmp[vehicleName] = {"message": t("errors.frontend.790-E-0407")};
                        allCorrect = false;
                    } else {
                        customErrorTmp["networkError"] = {"message": t("errors.frontend.790-E-0900")};
                        allCorrect = false;
                    }
                    count++;
                    console.log(count);
                    if(count == array.length){
                        console.log("AllCorrect: " + allCorrect);
                        setCustomError(customErrorTmp);
                        onCustomError(customErrorTmp);
                        if(allCorrect){
                            console.log('onSubmit: ', formData, formData.vehicleGp);
                            setValues(formData);
                            history.push(`${process.env.REACT_APP_SUB_ROUTE}/locationDetail`);
                        }
                    }
                })
            }
        })
    };
    
    const onError = (errors) => {
        setCustomError();
        scroll.scrollToTop();
        setOpen(false);
    }

    const onCustomError = (error) => {
        scroll.scrollToTop();
        setOpen(false);
    }

	const checkRegistration = (regMark, issueDate) => {
		let formattedIssueDate = formatDate(issueDate);
		//var vehicleDetails = validateVehicle(regMark);
		return validateVehicle(regMark)
		.then((result) => (result))
		.then((vehicleDetails) =>{
            if(isObjectEmpty(vehicleDetails)){
                return 9999
            }
			//httpak console.log
			console.log(vehicleDetails);
			console.log("RegMark: " + vehicleDetails.RegMark);
			console.log("VehicleType: " + vehicleDetails.VehicleType);
			console.log("ExpiryDate: " + vehicleDetails.ExpiryDate);
			console.log("IssueDate: " + vehicleDetails.IssueDate);
			console.log("FormattedIssueDate: " + formatDate(vehicleDetails.IssueDate));
			if(vehicleDetails.RegMark == true){
			console.log("InputDate: " + formattedIssueDate);
				if(data.applicantType=="Government"&&vehicleDetails.VehicleType == "G"){
					//Don't validate if AM
					return 0;
				}else if(formatDate(vehicleDetails.IssueDate) == formattedIssueDate || vehicleDetails.IssueDate.substring(0, 10) == formattedIssueDate){
				console.log("ExpiryDate: " + vehicleDetails.ExpiryDate);
					let expired = false;
					data.dateTimeGp.forEach((date) => {
						let checkDate = formatDate(date.startDate);
						console.log("Checking Date: " + checkDate);
						if(vehicleDetails.ExpiryDate < checkDate){
							console.log("Vehicle Expiry Date earlier than Application Date");
							expired = true;
						}
					});
					if(expired){
						//The Expiry Date of the Vehicle is earlier than one of the Application Period Start Date
						return 2;
					}else{
						//OK
						return 0;
					}
				}else{
					//Issue Date is Wrong
					return 1;
				}
			}else{
				//Vehicle Not Valid
				return 3;
			}
		})
        .catch((e)=>{
            console.log("network error: ", e);
            return 9999
        })
	}
	
	const validateVehicle = (regMark) => {
		const URL = `${window.location.origin}/EPASService/application/validateVehicle`;
		let postOption = {
		  method: 'POST',
		  body: JSON.stringify({regMark: regMark})
		}
		return fetch(URL, postOption)
		.then((response)=>(response.json()))
		.then((json)=>{
		  console.log(json);
		  let vehicleDetails = JSON.parse(json.data);
		  console.log(vehicleDetails);
		  return vehicleDetails;
		})
		.catch((reason)=>{
            console.log("fetch error, reason: ", reason)
            return null
        });
	}
  
	const formatDate = (date) => {
		let d = new Date(date),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) 
			month = '0' + month;
		if (day.length < 2) 
			day = '0' + day;

		return [year, month, day].join('-');
	}

    useEffect(() => {
        scroll.scrollToTop();
    }, []);

    const handleReset = () => {
        scroll.scrollToTop();
    	clearErrors();
        let newState = {
            vehicleDetail: 'direct',
            vehicleGp: [{
                vehicleRegNo: '',
                issueDate: '',
            }]
        }
        setValues(newState);

        reset({
            vehicleDetail: 'direct',
            vehicleGp: [{
                vehicleRegNo: '',
                issueDate: '',
            }]
        })
    }

    const handleRemoveItem = (index) => {
        console.log('before delete:', index, fields, data.vehicleGp)
        remove(index)
        console.log('after delete: ', fields,'data.vehicleGp: ', data.vehicleGp)
        console.log('after delete and return ', {data, fields})
    }
	
	
	
    const handleBack = () => {
        if (data.applicationType === 'Replace') history.push(`./selectService`);
        else history.push(`${process.env.REACT_APP_SUB_ROUTE}/dateTimeDetail`);
    }

    const handleState = (newVehicleGp) => {
        if(newVehicleGp && newVehicleGp["vehicleGp"].length>0){
            if(newVehicleGp["vehicleGp"].length<=10){
                if(newVehicleGp && newVehicleGp["vehicleGp"]){
                    remove()
                    newVehicleGp["vehicleGp"].forEach(({vehicleRegNo, issueDate},index)=>{
                        append({vehicleRegNo, issueDate})
                        setValue(`vehicleGp[${index}].vehicleRegNo`, vehicleRegNo);
                        setValue(`vehicleGp[${index}].issueDate`, issueDate);
                        // document.getElementById(`vehicleGp[${index}].vehicleRegNo`).value=vehicleRegNo
                        // const input = document.getElementById(`vehicleGp[${index}].issueDate`);
                        // const lastValue = input.value;
                        // input.value = issueDate;
                        // const event = new Event("input", { bubbles: true });
                        // const tracker = input._valueTracker;
                        // if (tracker) {
                        //     tracker.setValue(lastValue);
                        // }
                        // input.dispatchEvent(event);
                    })
                }
            } else {
                setCustomError({"vehicleGpLimit":{"message": t('step3.vehicle.vehicleLimit')}});
                scroll.scrollToTop();
            }
        }
    };
console.log('lang: ', i18n.language)
    console.log('before return', {data, fields})

    console.log('custom error: ', customError);
    console.log('errors: ', errors);
    console.log("watch: ", watch());
    console.log("data: ", data);
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    
    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }
    
    return (
        <main>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                >
                    <Fade in={open}>
                    <div className={classes.paper}>
                        <LoadingSpinner />
                        <h2 id="transition-modal-title" className="center">{t('confirmation.modalMessage.validate')}</h2>
                        <h2 id="transition-modal-description"  className="center">{t('confirmation.modalMessage.wait')}</h2>
                    </div>
                    </Fade>
                </Modal>
            </div>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-005'}</title>
            </Helmet>
            <Box className="wrapper vehicleDetail">
                <Header langLock="langLocked" />
                <Box className="mainWrapper">
                    <Navbar step="step3" />
                    <Box className="contentWrapper">
                        <ErrorsContainer errors={{...errors, ...customError}} />
                        <StepHeader
                            step="common.step3"
                            title="step3.vehicleTitle"
                            mandatory
                            pointsToNote4
                        />
                        <form
                            onSubmit={handleSubmit(onSubmit, onError)}
                            onReset={handleReset}
                            noValidate
                        >
                            <FormBox header="step3.vehicle.title">
                                <Box p={5}>
                                    <Box mb={6}>
                                        <FormControl
                                            component="fieldset"
                                            error={!!errors.vehicleGp}
                                        >
                                            <FormLabel
                                                component="legend"
                                            >
                                                {t('step3.vehicle.vehicleDetail')} <Box component="span" className="danger">*</Box>
                                            </FormLabel>
                                            <Controller
                                                control={control}
                                                name="vehicleDetail"
                                                defaultValue={data.vehicleDetail}
                                                as={
                                                    <RadioGroup
                                                        aria-label="vehicleDetail"
                                                    >
                                                        <FormControlLabel
                                                            value="direct"
                                                            control={<Radio />}
                                                            label={t('step3.vehicle.vehicleDetailOpt1')}
                                                        />
                                                        <FormControlLabel
                                                            value="upload"
                                                            control={<Radio />}
                                                            label={t('step3.vehicle.vehicleDetailOpt2')}
                                                        />
                                                    </RadioGroup>
                                                }
                                            />
                                        </FormControl>
                                    </Box>
                                </Box>
                                    {/* vehicleDetailSelected === 'direct' && */}
                                {
                                    fields && fields.map((item, index) => {
                                        console.log("VD vehicleGp loop: ", {index, item});
                                        return (
                                            <Box
                                                p={5}
                                                mb={5}
                                                bgcolor={index%2 === 0 ? 'repeatInput.main' : 'repeatInput.secondary'}
                                                key={item.id}
                                                // inputRef={register}

                                            >
                                                <Box
                                                    mb={6}
                                                    className="vehicleWrapper"
                                                >
                                                    <FormControl
                                                        className={"regNo"+((!!!errors["vehicleGp["+index+"].vehicleRegNo"] && !!errors["vehicleGp["+index+"].issueDate"]) || (!!!customError?.["vehicleGp["+index+"].vehicleRegNo"] && !!customError?.["vehicleGp["+index+"].issueDate"])?" regNoError":"")}
                                                        error={!!errors?.["vehicleGp["+index+"].vehicleRegNo"]}
                                                    >
                                                        <InputLabel shrink htmlFor={`vehicleGp[${index}].vehicleRegNo`}>
                                                            <div className={i18n.language == "tc"?"":"regmarkLebelEN"}>
                                                                {t('step3.vehicle.vehicleRegNo')}
                                                                <Box component="span" className="danger">*</Box>
                                                            </div>
                                                            
                                                            {!!errors?.["vehicleGp["+index+"].vehicleRegNo"] ? <img id={"vehicleGp["+index+"].vehicleRegNo_errorIcon"} className={i18n.language == "tc"?"errorWarningTC":"errorWarningEN"} src={errorWarning} alt="error" /> : <div></div>}
                                                            {!!customError?.["vehicleGp["+index+"].vehicleRegNo"] ? <img id={"vehicleGp["+index+"].vehicleRegNo_errorIcon"} className={i18n.language == "tc"?"errorWarningTC":"errorWarningEN"} src={errorWarning} alt="error" /> : <div></div>}
                                                        </InputLabel>
                                                        <BootstrapInput
                                                            name={`vehicleGp[${index}].vehicleRegNo`}
                                                            id={`vehicleGp[${index}].vehicleRegNo`}
                                                            inputProps={{ 
                                                                "aria-labelledby": `vehicleGp[${index}].vehicleRegNo` 
                                                            }}
                                                            defaultValue={item.vehicleRegNo}
                                                            ref={register()}
                                                        />
                                                    </FormControl>

                                                    <FormControl
                                                        className={"issueDate"+((!!errors["vehicleGp["+index+"].vehicleRegNo"] && !!!errors["vehicleGp["+index+"].issueDate"]) || (!!customError?.["vehicleGp["+index+"].vehicleRegNo"] && !!!customError?.["vehicleGp["+index+"].issueDate"])  ?" issueDateError":"")}
                                                        error={!!errors?.["vehicleGp["+index+"].issueDate"]}
                                                    >
                                                        <InputLabel shrink htmlFor={`vehicleGp[${index}].issueDate`}>
                                                            <div style={{display:"inline-block"}}>
                                                                {t('step3.vehicle.issueDate')}
                                                                {i18n.language == "tc"?"":"(YYYY-MM-DD)"}
                                                                <Box component="span" className="danger">*</Box>
                                                            </div>
                                                            {!!errors?.["vehicleGp["+index+"].issueDate"] ? <img id={"vehicleGp["+index+"].issueDate_errorIcon"} className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                            {!!customError?.["vehicleGp["+index+"].issueDate"] ? <img id={"vehicleGp["+index+"].issueDate_errorIcon"} className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                        </InputLabel>
                                                        {/* Date of Issue of Vehicle Registration Doc - written by Simon */}
                                                        {/* <BootstrapInput
                                                            name={`vehicleGp[${index}].issueDate`}
                                                            defaultValue={`${item.issueDate}`}
                                                            inputRef={register}

                                                            error={!!errors?.dateTimeGp?.[index]?.issueDate}
                                                            helperText={errors?.dateTimeGp?.[index]?.issueDate?.message}
                                                        /> */}
                                                        {/* <Controller
                                                            // name={name}
                                                            rules={{ required: true }}
                                                            control={control}

                                                            // initialFocusedDate={null}
                                                            defaultValue={null}

                                                            as={ */}
                                                            {/* {console.log(item.issueDate)}
                                                                <DatePicker
                                                                    id={`vehicleGp[${index}].issueDate`}
                                                                    name={`vehicleGp[${index}].issueDate`}
                                                                    disableFuture={true}
                                                                    // inputRef={register}
                                                                    value={item.issueDate}
                                                                    defaultValue={item.issueDate}
                                                                    ref={register()}
                                                                    KeyboardButtonProps={{
                                                                        "aria-label": "issueDate",
                                                                    }}
                                                                    inputProps={{
                                                                        readOnly: true,
                                                                        "aria-label": "issueDate",
                                                                    }}
                                                                /> */}
                                                                <Controller 
                                                                    control={control}
                                                                    name={`vehicleGp[${index}].issueDate`}
                                                                    render={(props)=>{
                                                                        console.log("props.value: ", props.value)
                                                                        return <InputMask mask="9999-99-99" value={props.value}
                                                                            onChange={props.onChange}
                                                                            beforeMaskedValueChange={dateMask}
                                                                        >
                                                                            {(inputProps) => (
                                                                                <Input
                                                                                    id={`vehicleGp[${index}].issueDate`}
                                                                                    error={errors?.["vehicleGp["+index+"].issueDate"]}
                                                                                    inputProps={{
                                                                                        lang:"en-US"
                                                                                    }}
                                                                                    placeholder={t("step3.dateTime.datePlaceholder")}
                                                                                    {...inputProps}
                                                                                />
                                                                        )}
                                                                        </InputMask>
                                                                        // return <Input value={props.value} onChange={props.onChange}/>
                                                                    }}
                                                                />
                                                    </FormControl>
                                                </Box>

                                                {
                                                    vehicleGpWatch.length > 1 &&
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        className="removeBtn"
                                                        onClick={() => {
                                                            console.log("item", item)
                                                            handleRemoveItem(index)
                                                        }}
                                                    >
                                                        {t('common.button.remove')}
                                                    </Button>
                                                }
                                            </Box>
                                        );
                                    })
                                }
                                {
                                    vehicleDetailSelected === 'direct' && fields && fields.length < 10 &&
                                        <Box
                                            p={5}
                                        >
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handleAddVehicle}
                                            >
                                                {t('step3.vehicle.addVehicle')}
                                            </Button>
                                            {t("step3.vehicle.addVehicleIfNeed", "*Add vehicle if you need")}
                                        </Box>
                                }
                                {
                                    vehicleDetailSelected === 'upload' && (
                                        <Controller
                                            control={control}
                                            name="fileInput"
                                            render={(onChange, name, ref) => (
                                                <Box
                                                    p={5}
                                                >
                                                    <Typography variant="body1">
                                                        {t('step3.vehicle.uploadDesc')}
                                                    </Typography>
                                                    <FileInput
                                                        name="vehicleGpFiles"
                                                        control={control}
                                                        maxFiles="1"
                                                        fileType=".xls, .xlsx"
                                                        state={data}
                                                        stateKey={"vehicleGp"}
                                                        page="vehicleDetail"
                                                        onChange={handleState}
                                                    />
                                                </Box>
                                            )}
                                        />
                                    )
                                }
                            </FormBox>
                            <FormBox header="step3.note.title">
								<Box p={5} bgcolor="tnc.main" className="letterFrameBorder">
									<Box className="letterFrame">
										<img src={sampleLetter} alt="" className="letterImg"/>
									</Box>
								</Box>
							</FormBox>
                            <FormBox>
                                <Box
                                    display="flex"
                                    justifyContent="flex-end"
                                >
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        className="secBtn"
                                        onClick={handleBack}
                                    >
                                        {t('common.button.back')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        type="reset"
                                        className="secBtn"
                                    >
                                        {t('common.button.clear')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                    >
                                        {t('common.button.next')}
                                    </Button>
                                </Box>
                            </FormBox>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Footer />
        </main>
    )
})
